import React from 'react';
import { Button, Col, Divider, Row, Typography } from 'components';
import { EditIcon, MapIcon } from 'components/common/icons';
import { AddressEdit } from 'feature/clientTabs/general/address/edit';
import { useAddress } from 'feature/clientTabs/general/address/useAddress';
import styles from './styles.module.scss';
import { HasAccess } from 'components/common/accessControl';
import { PERMISSIONS } from 'constants/permissions';

const { Text } = Typography;

export const Address = React.memo(() => {
  const { onModalOpen, isOpen, onModalClose, clientDetails, countryDetails } = useAddress();
  return (
    <>
      <Row className={styles.address} gutter={[0, 12]}>
        <Col span={24} className={styles.title_box}>
          <Row align={'middle'} justify={'space-between'}>
            <Col>
              <Row className={styles.title_container} align={'middle'}>
                <MapIcon />
                <Col>
                  <Text style={{ fontWeight: 600, color: '#222530' }}>Address</Text>
                </Col>
              </Row>
            </Col>
            <HasAccess role={PERMISSIONS.clients.address.write}>
              <Button type={'link'} icon={<EditIcon />} onClick={onModalOpen} />
            </HasAccess>
          </Row>
        </Col>
        <Col span={24}>
          <Divider className={styles.divider} />
        </Col>
        <Col flex={'276px'}>
          <Row>
            {countryDetails.commonName && (
              <Col span={24}>
                <Text className={styles.text}>{countryDetails.commonName}</Text>
              </Col>
            )}
            {clientDetails.state && (
              <Col span={24}>
                <Text className={styles.text}>{clientDetails.state}</Text>
              </Col>
            )}
            {clientDetails.city && (
              <Col span={24}>
                <Text className={styles.text}>{clientDetails.city}</Text>
              </Col>
            )}
            {clientDetails.street && (
              <Col span={24}>
                <Text className={styles.text}>{clientDetails.street}</Text>
              </Col>
            )}
          </Row>
        </Col>
        <Col flex={'276px'}>
          {clientDetails.zip && (
            <Row>
              <Col span={24}>
                <Text className={styles.text_small}>ZIP</Text>
              </Col>
              <Col span={24}>
                <Text className={styles.text}>{clientDetails.zip}</Text>
              </Col>
            </Row>
          )}
        </Col>
      </Row>
      <AddressEdit onModalStateChange={onModalClose} modalState={isOpen} dataToEdit={clientDetails} />
    </>
  );
});
